module.exports = __webpack_public_path__ + "img/04complaint_center.b8c8b333.png";